import { Box, Button, Stack, Typography } from "@mui/material";
import { Link } from "react-router";

export function NotFoundPage() {
  return (
    <Box sx={{ display: "grid", placeItems: "center", flexGrow: 1, minHeight: 0, p: 3, textAlign: "center" }}>
      <Stack spacing={2} sx={{ alignItems: "center" }}>
        <Typography variant="h3" component="h1" color="text.disabled">
          404
        </Typography>
        <Typography variant="body1" color="text.secondary">
          找不到這個頁面。
        </Typography>
        <Button component={Link} to="/" variant="contained">
          回到總覽
        </Button>
      </Stack>
    </Box>
  );
}
